module.exports = __webpack_public_path__ + "img/beacon-antenna-shadow.a2268718.png";